const React = require('react');
const PropTypes = require('prop-types');

/**
 * Time Unit React Element, renders days, hours, minutes or seconds
 */
export default function TimeUnit({
  value, label, show, color
}) {
  return show ? (
    <span className={`item ${color}`}>
      {value}
      {' '}
      {label}
    </span>
  ) : (<span />);
}

TimeUnit.propTypes = {
  value: PropTypes.number,
  label: PropTypes.string,
  show: PropTypes.bool,
  color: PropTypes.string.isRequired
};

TimeUnit.defaultProps = {
  value: 0,
  label: '',
  show: false
};
